<script setup lang="ts">
    const props = defineProps<{
        plan?: 'pro' | 'enterprise' | 'growth';
        tooltipLocation?: 'top' | 'bottom' | 'left' | 'right';
        variant?: 'default' | 'lightning';
    }>();
</script>

<template>
    <!-- Lightning variant: small round badge with bolt icon -->
    <span
        v-if="variant === 'lightning'"
        class="inline-flex items-center justify-center size-[20px] rounded-full bg-[#0b1a2b] shrink-0"
    >
        <i class="fa-sharp fa-solid fa-bolt text-[8px] text-[#00e1c6]" />
    </span>

    <!-- Default variant: text badge with plan name -->
    <span
        v-else
        class="px-3 py-1 text-xs text-[#5c460b] rounded-lg bg-gold-gradient font-semibold"
        :data-tooltip="$t('upsell_badge.tooltip', { plan })"
        :data-tooltip-location="tooltipLocation ?? 'top'"
    >
        <span class="uppercase">
            {{ plan }}
        </span>
    </span>
</template>
